import type { FC } from "react";
import { useState } from "react";

interface SkeletonFaviconProps {
    src: string;
    alt: string;
    size?: number;
    fallbackSrc: string;
}

export const SkeletonFavicon: FC<SkeletonFaviconProps> = ({
                                                              src,
                                                              alt,
                                                              size = 16,
                                                              fallbackSrc,
                                                          }) => {
    const [loaded, setLoaded] = useState(false);
    const [error, setError] = useState(false);

    return (
        <div
            style={{
                width: size,
                height: size,
                borderRadius: 4,
                overflow: "hidden",
                backgroundColor: loaded && !error ? "transparent" : "#f0f0f0", // shimmer grey background until loaded
                display: "inline-flex",
                alignItems: "center",
                justifyContent: "center",
            }}
        >
            <img
                src={error ? fallbackSrc : src}
                alt={alt}
                style={{
                    width: size,
                    height: size,
                    opacity: loaded ? 1 : 0,
                    transition: "opacity 0.3s ease-in-out",
                }}
                onLoad={() => setLoaded(true)}
                onError={() => {
                    setError(true);
                    setLoaded(true);
                }}
            />
        </div>
    );
};
